(function () {
  var SCRIPTS = window.__wbnDeferredScripts || [];
  if (!SCRIPTS.length) return;
  var TRIGGERS = ['click', 'touchstart', 'scroll', 'keydown', 'mousemove'];
  // 3000: lower (1500) overlapped the wbn-lazy-init replay burst and regressed SI.
  var FALLBACK_MS = 3000;
  var STAGGER_STEP_MS = 120;
  var loaded = false;
  function loadAll(evt) {
    // isTrusted guard: widgets that .click() their default option on init must not count.
    if (evt && evt.isTrusted === false) return;
    if (loaded) return;
    loaded = true;
    var pending = SCRIPTS.length;
    function settle() {
      if (--pending > 0) return;
      // consumers (assets/tlpc_js.js) wait for this instead of assuming gsap exists
      try { window.dispatchEvent(new Event('wbn:polish-loaded')); } catch (_) {}
    }
    function appendScript(src) {
      var s = document.createElement('script');
      s.src = src;
      s.async = false;
      s.onload = settle;
      s.onerror = settle;
      document.head.appendChild(s);
    }
    for (var i = 0; i < SCRIPTS.length; i++) {
      if (i === 0) {
        appendScript(SCRIPTS[i]);
      } else {
        (function (src, delay) {
          setTimeout(function () { appendScript(src); }, delay);
        })(SCRIPTS[i], i * STAGGER_STEP_MS);
      }
    }
  }
  // not { once: true }: an untrusted event must not consume the listener
  var opts = { passive: true };
  for (var t = 0; t < TRIGGERS.length; t++) {
    window.addEventListener(TRIGGERS[t], loadAll, opts);
  }
  setTimeout(loadAll, FALLBACK_MS);
})();
